import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../../utils/config';
import './style.scss';

type FilterOption = {
  i18nKey: string;
  collectionPointType: string;
};

type FiltersProps = {
  onClick: (filter: string) => void;
  availableFilters: FilterOption[];
  activeFilter: string;
};

const Filters = (props: FiltersProps) => {
  const { onClick, availableFilters, activeFilter } = props;

  return (
    <div className="filters">
      <ul>
        {availableFilters.map(filter => {
          const isFilterActive = activeFilter === filter.collectionPointType;
          const filterImage = getAssetUrl(`collectionPoints/squares/${filter.i18nKey}.svg`);

          return (
            <li
              className={classNames({ 'active-filter': isFilterActive })}
              onClick={() => onClick(isFilterActive ? '' : filter.collectionPointType)}
              key={filter.collectionPointType}
            >
              <img src={filterImage} />
              <FormattedMessage id={`shipping.collectionPoint.types.${filter.i18nKey}`} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Filters;
